import { createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { Tag } from '../types';
import { RequestStatusEnum } from '@shared/types';

export type TagsState = {
    tags: Tag[];
    getTagsStatus: RequestStatusEnum;
    getTagsError: AxiosError | null;
    addTagStatus: RequestStatusEnum;
    addTagError: AxiosError | null;
    deleteTagStatus: RequestStatusEnum;
    deleteTagError: AxiosError | null;
};

const initialState: TagsState = {
    tags: [],
    getTagsStatus: RequestStatusEnum.NotRequested,
    getTagsError: null,
    addTagStatus: RequestStatusEnum.NotRequested,
    addTagError: null,
    deleteTagStatus: RequestStatusEnum.NotRequested,
    deleteTagError: null,
};

const tagsSlice = createSlice({
    name: '@tags',
    initialState,
    reducers: {
        getTagsRequest(state) {
            state.getTagsStatus = RequestStatusEnum.Loading;
            state.getTagsError = null;
        },
        getTagsSuccess(state, action) {
            state.getTagsStatus = RequestStatusEnum.Success;
            state.getTagsError = null;
            state.tags = action.payload.data;
        },
        getTagsError(state, action) {
            state.getTagsStatus = RequestStatusEnum.Error;
            state.getTagsError = action.payload;
            state.tags = [];
        },
        getTagsReset(state) {
            state.getTagsStatus = RequestStatusEnum.NotRequested;
            state.getTagsError = null;
            state.tags = [];
        },
        addTagRequest(state) {
            state.addTagStatus = RequestStatusEnum.Loading;
            state.addTagError = null;
        },
        addTagSuccess(state) {
            state.addTagStatus = RequestStatusEnum.Success;
            state.addTagError = null;
        },
        addTagError(state, action) {
            state.addTagStatus = RequestStatusEnum.Error;
            state.addTagError = action.payload;
        },
        addTagReset(state) {
            state.addTagStatus = RequestStatusEnum.NotRequested;
            state.addTagError = null;
        },

        deleteTagRequest(state) {
            state.deleteTagStatus = RequestStatusEnum.Loading;
            state.deleteTagError = null;
        },
        deleteTagSuccess(state) {
            state.deleteTagStatus = RequestStatusEnum.Success;
            state.deleteTagError = null;

            state.getTagsStatus = RequestStatusEnum.NotRequested;
            state.getTagsError = null;
        },
        deleteTagError(state, action) {
            state.deleteTagStatus = RequestStatusEnum.Error;
            state.deleteTagError = action.payload;
        },
        deleteTagReset(state) {
            state.deleteTagStatus = RequestStatusEnum.NotRequested;
            state.deleteTagError = null;
        },
    },
});

export default tagsSlice.reducer;

export const {
    getTagsRequest,
    getTagsSuccess,
    getTagsError,
    getTagsReset,
    addTagRequest,
    addTagSuccess,
    addTagError,
    addTagReset,
    deleteTagRequest,
    deleteTagSuccess,
    deleteTagError,
    deleteTagReset,
} = tagsSlice.actions;
